import { Link } from 'react-router';
import { Button, Container, Group, Text, Title } from '@mantine/core';
import classes from './not-found.module.css';

export const NotFound = () => {
  return (
    <Container className={classes.root}>
      <div className={classes.label}>404</div>
      <Title className={classes.title}>Страница не найдена</Title>
      <Group justify="center">
        <Text c="dimmed" size="lg" ta="center" className={classes.description}>
          К сожалению, такая страница не существует. Возможно, вы ввели не верный адрес URL.
        </Text>
      </Group>
      <Group justify="center">
        <Button variant="subtle" size="md" component={Link} to="/dashboard">
          Вернуться обратно на главную страницу
        </Button>
      </Group>
    </Container >
  );
}
